var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "files" }, [
    _c("div", { staticClass: "row" }, [
      _vm.files.length
        ? _c(
            "div",
            { staticClass: "col-default-12 files__container" },
            [
              _c("z-filelist", [
                _c(
                  "div",
                  { staticClass: "files__item" },
                  _vm._l(_vm.files, function (file, index) {
                    return _c(
                      "z-filelist-item",
                      {
                        key: index,
                        attrs: {
                          icon: "file/" + file.file.type,
                          info: file.file.size,
                          date: _vm.getFileDate(file.activeFrom) || null,
                        },
                      },
                      [
                        _c("z-link", { attrs: { href: file.file.link } }, [
                          _vm._v(" " + _vm._s(file.name) + " "),
                        ]),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.foldersWithFiles.length
        ? _c(
            "div",
            { staticClass: "col-default-12" },
            [
              _c(
                "z-accordion",
                _vm._l(_vm.foldersWithFiles, function (folder, index) {
                  return _c("z-accordion-item", {
                    key: index,
                    attrs: { id: _vm.type + "-" + folder.code },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [_c("span", [_vm._v(_vm._s(folder.name))])]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("z-filelist", [
                                _c(
                                  "div",
                                  { staticClass: "files__item" },
                                  _vm._l(folder.items, function (file, index) {
                                    return _c(
                                      "z-filelist-item",
                                      {
                                        key: index,
                                        attrs: {
                                          icon: "file/" + file.file.type,
                                          info: file.file.size,
                                          date:
                                            _vm.getFileDate(file.activeFrom) ||
                                            null,
                                        },
                                      },
                                      [
                                        _c(
                                          "z-link",
                                          { attrs: { href: file.file.link } },
                                          [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }